<template>
  <vs-prompt buttons-hidden	class="large" :title="data.id ? 'تعديل إختبار' : 'إضافة إختبار جديد'" :active="active" @close="close">
      <h4 class="mb-6">بيانات الاختبار</h4>

      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <vs-input class="w-full" label="العنوان" v-model="formData.title"
                    v-validate="'required'"  name="title" data-vv-as="العنوان" />
          <span class="text-danger text-sm" v-show="errors.has('title')">{{ errors.first('title') }}</span>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col sm:w-1/3 w-full mb-base">
          <label>وقت الاختبار</label>
          <flat-pickr class="w-full" :config="configDateTimePicker" v-model="formData.date_time"
                      v-validate="'required'" name="date_time" data-vv-as="وقت الاختبار" />
          <span class="text-danger text-sm" v-show="errors.has('date_time')">{{ errors.first('date_time') }}</span>
        </div>
        <div class="vx-col sm:w-1/3 w-1/2 mb-base">
          <label>مدة الاختبار</label>
          <vx-input-group>
            <vs-input class="w-full" v-model="formData.duration"
                      v-validate="'required|numeric'" name="duration" data-vv-as="مدة الاختبار" />

            <template slot="append">
              <div class="append-text bg-primary">
                <span>دقيقة</span>
              </div>
            </template>
          </vx-input-group>
          <span class="text-danger text-sm" v-show="errors.has('duration')">{{ errors.first('duration') }}</span>
        </div>
        <div v-if="!formData.id" class="vx-col mb-base">
          <label>عدد نماذج الاختبار</label>
          <vs-input-number v-model="formData.groups_num"
                           v-validate="'required|numeric'"  name="groups_num" min="1" data-vv-as="عدد نماذج الاختبار" />
          <span class="text-danger text-sm" v-show="errors.has('groups_num')">{{ errors.first('groups_num') }}</span>
        </div>
      </div>

      <div v-if="!formData.id" class="vx-row">
        <div class="vx-col mb-base">
          <label>اختر المجموعات</label>
          <ul class="centerx flex flex-wrap">
            <li v-for="(group, index) in getCourseDetails.groups" :key="index">
              <vs-checkbox v-model="formData.groups" :vs-value="group.group"
                           v-validate="'required'" name="groups" data-vv-as="المجموعات" data-vv-validate-on="change">
                {{group.group}}
              </vs-checkbox>
            </li>
          </ul>
          <span class="text-danger text-sm" v-show="errors.has('groups')">يجب اختيار مجموعة واحده علي الاقل</span>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-base">
          <label>إعدادات الاختبار</label>
          <ul>
            <li v-if="!formData.id" class="mt-4">
              <vs-checkbox v-model="formData.randomize_students" description="test">توزيع الطلبة على نماذج الاختبار</vs-checkbox>
              <span v-if="!formData.randomize_students" class="mt-2 text-danger block ml-8">* إذا قمت بإلغاء هذا الاختيار يجب عليك الدخول إلى تفاصيل الاختبار ثم طلبة الاختبار كي تقوم بتوزيع الطلبة على نماذج الاختبار</span>
            </li>
            <li class="mt-4">
              <vs-checkbox v-model="formData.randomize_questions">عشوائية الاسئلة</vs-checkbox>
            </li>
          </ul>
        </div>
      </div>

      <vs-divider />
      <div class="flex justify-end">
        <vs-button @click="close" class="mx-5" type="flat">رجوع</vs-button>
        <vs-button @click="submitClicked">حفظ</vs-button>
      </div>
  </vs-prompt>
</template>
<script>
    import flatPickr from 'vue-flatpickr-component'
    import 'flatpickr/dist/flatpickr.css'
    import { Arabic } from "flatpickr/dist/l10n/ar.js"
    import quizzesAPI from "@/api/quizzesAPI"

    export default {
        name: 'quiz-form',
        components:{
            flatPickr,
        },
        props: {
            data: {
                default: () => {},
                type: Object
            },
            active: {
                default: false,
                type: Boolean
            }
        },
        watch: {
            active(val) {
                if(!val) return

                this.initValues()
                Object.assign(this.formData, this.data)
            }
        },
        data() {
            return {
                course_id: this.$route.params.course_id,
                formData: {
                    title: '',
                    date_time: '',
                    duration: null,
                    groups_num: 1,
                    randomize_questions: false,
                    groups: [],
                    randomize_students: true,
                },
                configDateTimePicker: {
                    disableMobile: "true",
                    minDate: this.$store.state.date,
                    minuteIncrement: 1,
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    locale: Arabic,
                    time_24hr: true,
                },
            }
        },
        methods: {
            submitClicked(){
                this.$validator.validateAll().then((result) => {
                    if(result) {
                        this.$startLoading()
                        this.formData.course_id = this.course_id
                        if(this.formData.id) {
                            this.updateQuiz()
                        } else {
                            this.addQuiz()
                        }
                    }
                })
            },
            addQuiz(){
                quizzesAPI.create(this.formData)
                    .then(response => {
                        this.formData.id = response.data.id
                        this.submitRequest()
                        this.$notifySuccess(response.successMessage)
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
                    .finally(() => this.$closeLoading())
            },
            updateQuiz(){
                const quizData = Object.assign({}, this.formData)
                delete quizData.groups
                quizzesAPI.update(this.formData.id, quizData)
                    .then((response) => {
                        this.submitRequest()
                        this.$notifySuccess(response.successMessage)
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
                    .finally(() => this.$closeLoading())
            },
            // this method calls when the request is success and delivered
            submitRequest(){
                let data = {}
                Object.assign(data, this.formData)
                this.$emit('submit', data)
                this.close()
            },
            close(){
                this.$emit('update:active', false)
            },
            initValues(){
                this.formData = {
                    title: '',
                    date_time: null,
                    duration: 30,
                    groups_num: 1,
                    randomize_questions: false,
                    randomize_students: true,
                    groups: [],
                }
                this.$validator.reset()
            },
        },
    }
</script>
